import useI18nNamespace from "@services/useI18nNamespace";
import { useCallback } from "react";
import { dangerToast } from "@lib/brazeToaster";

export const useDashboardApiMutationErrorToast = (errorMessage?: string) => {
  const { t } = useI18nNamespace("dashboard-api-errors");
  return useCallback(() => {
    dangerToast(errorMessage || t("mutation-api-failed", "Unable to perform action"));
  }, [errorMessage, t]);
};
